import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import SignatureCanvas from 'react-signature-canvas';
import Close from '../../../common/ui/Close';

export default class SignatureModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    submitJobApprovalEmployer: PropTypes.func.isRequired
  };

  state = {
    messageIsShown: true
  };

  sigPad = {};

  clear = () => {
    this.sigPad.clear();
  };

  hideMessage = () => {
    this.setState({
      messageIsShown: false
    });
  };

  cancelApproval = () => this.props.UIShowConfirm(
    'Without a signature, the hours won\'t be approved',
    () => {
      this.setState({ messageIsShown: true });
      this.clear();
      this.props.closeModal();
    }
  );

  submitSignature = () => {
    const trimmedDataURL = this.sigPad.getTrimmedCanvas().toDataURL('image/png');
    this.props.submitJobApprovalEmployer(trimmedDataURL);
  };

  render () {
    return (
      <Modal isOpen={this.props.isOpen}>
        <div className='modal-header'>
          <div className='modal-title'>Approve Hours</div>
          <Close onClick={this.cancelApproval} />
        </div>

        <div className='modal-body'>
          <div className='signature-canvas-wrapper'>
            { this.state.messageIsShown ? (
              <div className='sign-message'>
                <h2 className='title'>Provide Signature</h2>
                <p>
                  <span className='mr-1 text-info info-icon'><FontAwesomeIcon icon={faInfoCircle} /></span>
                  Using your mouse please draw your signature to confirm the hours
                </p>
              </div>
            ) : (
              <button
                className='button button-primary approve-signature-button'
                onClick={this.submitSignature}
              >Approve</button>
            )}
            <SignatureCanvas
              canvasProps={{ width: 500, height: 400, className: 'sigCanvas' }}
              ref={(ref) => { this.sigPad = ref; }}
              onBegin={this.hideMessage}
            />
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/WorkersTab/SignatureModal.js